export default __webpack_public_path__ + "static/media/Neuroprax-Pot-eng.9be3b953.jpg";